import ApiService from './api';

// 1Pay payment API service. Strictly self-pay: an agent pays for their OWN
// subscription. Agents never collect or pay on behalf of their sellers —
// agent-created sellers are covered by the agent's plan automatically.
class PaymentService {
  static async initiatePayment({ plan, billingCycle = 'monthly' }) {
    return ApiService.post('/payments/onepay/initiate', { plan, billingCycle });
  }

  static async getStatus(orderId) {
    return ApiService.get(`/payments/onepay/status/${orderId}`);
  }
}

export default PaymentService;
